import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/aboutus.png'
import _imports_1 from '@/assets/weixin.jpg'


const _withScopeId = n => (_pushScopeId("data-v-4c4a5e35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-us-main" }
const _hoisted_2 = {
  id: "about-us-img",
  ref: "aboutUsImg",
  class: "about-us-img"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "about-us",
  id: "company-profile"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_8 = { class: "about-us-company-profile" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-company-profile-backImg" }, null, -1))
const _hoisted_10 = { class: "nav" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "nav-about-us" }, "关于我们", -1))
const _hoisted_12 = { class: "about-us-company-profile-img" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-company-profile-img-bgc" }, null, -1))
const _hoisted_16 = { class: "about-us-company-profile-bgc" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "about-us-company-map" }
const _hoisted_19 = {
  id: "connect",
  class: "connect"
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_22 = { class: "about-us-connect" }
const _hoisted_23 = { class: "about-us-connect-left" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您也可以通过以下方式联系我们", -1))
const _hoisted_25 = { class: "about-us-connect-left-li" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-connect-left-li-title" }, "电子邮箱", -1))
const _hoisted_27 = { class: "about-us-connect-left-li" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-connect-left-li-title" }, "联系电话", -1))
const _hoisted_29 = { class: "about-us-connect-left-li" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-connect-left-li-title" }, "联系地址", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-us-connect-right" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "官方微信")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bm_marker = _resolveComponent("bm-marker")!
  const _component_bm_label = _resolveComponent("bm-label")!
  const _component_baidu_map = _resolveComponent("baidu-map")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _hoisted_4, 512),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.companyProfile.name), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.jump('company-profile'))),
            class: "nav-about-us-bt"
          }, _toDisplayString(_ctx.companyProfile.name), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jump('connect'))),
            class: "nav-about-us-bt"
          }, _toDisplayString(_ctx.connectUs.name), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("img", {
            src: _ctx.companyProfile.img
          }, null, 8, _hoisted_14),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "about-us-company-profile-content",
            innerHTML: _ctx.companyProfile.content
          }, null, 8, _hoisted_17)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_baidu_map, {
          class: "map",
          zoom: 17,
          center: _ctx.point,
          enableWheelZoom: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bm_marker, { point: _ctx.point }, null, 8, ["point"]),
            _createVNode(_component_bm_label, {
              styles: _ctx.styles,
              offset: [15, -40],
              content: "陕西省西安市雁塔区长安南路丽融大厦",
              position: _ctx.point,
              show: true
            }, null, 8, ["styles", "position"])
          ]),
          _: 1
        }, 8, ["center"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.connectUs.name), 1),
        _hoisted_21
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("div", null, [
                _createVNode(_component_svg_icon, {
                  class: "connect-icon",
                  name: "youxiang",
                  color: 'blue'
                })
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("div", null, _toDisplayString(_ctx.cmsDetail.cmsEmail), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createElementVNode("div", null, [
                _createVNode(_component_svg_icon, {
                  class: "connect-icon",
                  name: "dianhua",
                  color: 'blue'
                })
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _createElementVNode("div", null, _toDisplayString(_ctx.cmsDetail.cmsTel), 1)
              ])
            ]),
            _createElementVNode("li", _hoisted_29, [
              _createElementVNode("div", null, [
                _createVNode(_component_svg_icon, {
                  class: "connect-icon",
                  name: "ditu",
                  color: 'blue'
                })
              ]),
              _createElementVNode("div", null, [
                _hoisted_30,
                _createElementVNode("div", null, _toDisplayString(_ctx.cmsDetail.cmsAddress), 1)
              ])
            ])
          ])
        ]),
        _hoisted_31
      ])
    ])
  ]))
}